///<reference path="../../employee/sections/employee.location.section.ts"/>
///<reference path="../../../components/models/meevo.model.custom.ts" />
module Meevo.Plugins.Student {
    /**
    * Location Section of Employee 
    */

    export class LocationSection extends Meevo.Plugins.Employee.LocationSection {
        public get auditNounForSave(): Model.NounEnum {
            return Model.NounEnum.StudentUserSecurity;
        }
    }
}